export const config = {
  modelName: 'studentSurvey',
  formName: 'studentSurvey',
} as const;
